import type { RouteLocationNormalized } from 'vue-router'
import { useUserStore } from '@/stores/user'
// import { message } from 'ant-design-vue'
import { useBreadcrumbStore } from '@/stores/breadcrumb'

export const authGuard = (to: RouteLocationNormalized) => {
  const userStore = useUserStore()

  if (!userStore.userInfo.tokenValue && to.name !== 'login') {
    // message.error(`登录失效，请重新登录`)
    return {
      name: 'login',
      // query: { redirect: to.fullPath },
    }
  }
  console.log('🔥🔥🔥authGuard', to)
  const breadcrumbStore = useBreadcrumbStore()
  const excludedRoutes = [
    'login',
    'notFound',
    'pointCloud',
    'tuananScreen',
    'wulidunScreen',
  ]
  if (to.name && !excludedRoutes.includes(to.name as string)) {
    breadcrumbStore.setRoutes({
      path: to.path as string,
      name: to.meta?.title as string,
      fullPath: to.fullPath as string,
      query: to.query,
    })
  }
}
